import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import LoginPage from '@/pages/LoginPage.vue'
import NotFoundPage from '@/pages/NotFoundPage.vue'
import ReferralCountListPage from '@/pages/dashboard/ReferralCountListPage.vue'
import SmsDashboardPage from '@/pages/dashboard/SmsDashboardPage.vue'
import SettingsPage from '@/pages/settings/SettingsPage.vue'
import QuizListPage from '@/pages/quiz/QuizListPage.vue'
import QuizAddEditPage from '@/pages/quiz/QuizAddEditPage.vue'
import QuizUserTriesListPage from '@/pages/quiz/QuizUserTriesListPage.vue'
import QuizUserTriesSummaryPage from '@/pages/quiz/QuizUserTriesSummaryPage.vue'
import QuizWinnersSummaryPage from '@/pages/quiz/QuizWinnersSummaryPage.vue'
import QuestionListPage from '@/pages/question/QuestionListPage.vue'
import QuestionAddEditPage from '@/pages/question/QuestionAddEditPage.vue'
import TelegramMemberListPage from '@/pages/telegrammember/TelegramMemberListPage.vue'
import MemberListPage from '@/pages/member/MemberListPage.vue'
import ReferralListPage from '@/pages/referral/ReferralListPage.vue'
import BroadcastListPage from '@/pages/broadcast/BroadcastListPage.vue'
import BroadcastAddEditPage from '@/pages/broadcast/BroadcastAddEditPage.vue'
import BroadcastSummaryPage from '@/pages/broadcast/BroadcastSummaryPage.vue'
import ActivationListPage from '@/pages/activation/ActivationListPage.vue'

Vue.use(Router)

function beforeEnter (to, from, next) {
  if (!store.getters.currentToken) {
    next('/login')
  } else {
    next()
  }
}

export default new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({y: 0}),
  routes: [
    {
      path: '/',
      redirect: '/quiz',
      name: 'Home',
      component: DefaultLayout,
      beforeEnter: beforeEnter,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          beforeEnter: beforeEnter,
          component: SmsDashboardPage
        },
        {
          path: 'referral-dashboard',
          name: 'ReferralDashboard',
          beforeEnter: beforeEnter,
          component: ReferralCountListPage
        },
        {
          path: 'quiz',
          name: 'Quiz',
          redirect: '/quiz/list',
          beforeEnter: beforeEnter,
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list',
              name: 'QuizList',
              component: QuizListPage
            },
            {
              path: 'add',
              name: 'QuizAdd',
              component: QuizAddEditPage
            },
            {
              path: 'edit/:id',
              name: 'QuizEdit',
              component: QuizAddEditPage
            },
            {
              path: 'user-tries/:quizId',
              name: 'UserTries',
              redirect: '/quiz/user-tries/:quizId/list',
              component: {
                render (c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'UserTriesList',
                  component: QuizUserTriesListPage
                },
                {
                  path: 'summary/:quizMemberId',
                  name: 'UserTriesSummary',
                  component: QuizUserTriesSummaryPage
                }
              ]
            },
            {
              path: 'winners/:id',
              name: 'QuizWinnersSummary',
              component: QuizWinnersSummaryPage
            }
          ]
        },
        {
          path: 'question',
          name: 'Question',
          redirect: '/question/list',
          beforeEnter: beforeEnter,
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list',
              name: 'QuestionList',
              component: QuestionListPage
            },
            {
              path: 'add',
              name: 'QuestionAdd',
              component: QuestionAddEditPage
            },
            {
              path: 'add-by-quiz/:quizId',
              name: 'QuestionAdd',
              component: QuestionAddEditPage
            },
            {
              path: 'edit/:id',
              name: 'QuestionEdit',
              component: QuestionAddEditPage
            }
          ]
        },
        {
          path: 'telegram-member',
          name: 'TelegramMember',
          redirect: '/telegram-member/list',
          beforeEnter: beforeEnter,
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list',
              name: 'TelegramMemberList',
              component: TelegramMemberListPage
            }
          ]
        },
        {
          path: 'member',
          name: 'Member',
          redirect: '/member/list',
          beforeEnter: beforeEnter,
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list',
              name: 'MemberList',
              component: MemberListPage
            }
          ]
        },
        {
          path: 'referral',
          name: 'Referral',
          redirect: '/referral/list',
          beforeEnter: beforeEnter,
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list',
              name: 'ReferralListPage',
              component: ReferralListPage
            }
          ]
        },
        {
          path: 'broadcast',
          name: 'Broadcast',
          redirect: '/broadcast/list',
          beforeEnter: beforeEnter,
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list',
              name: 'BroadcastList',
              component: BroadcastListPage
            },
            {
              path: 'add',
              name: 'BroadcastAdd',
              component: BroadcastAddEditPage
            },
            {
              path: 'summary/:id',
              name: 'BroadcastSummary',
              component: BroadcastSummaryPage
            }
          ]
        },
        {
          path: 'activation',
          name: 'Activation',
          redirect: '/activation/list',
          beforeEnter: beforeEnter,
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list',
              name: 'ActivationList',
              component: ActivationListPage
            }
          ]
        },
        {
          path: 'settings',
          name: 'Settings',
          beforeEnter: beforeEnter,
          component: SettingsPage
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: LoginPage
    },
    {
      path: '/404',
      name: 'NotFound',
      component: NotFoundPage
    },
    {
      path: '*',
      component: NotFoundPage
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js